<iframe #frame title="Acompanhamento Comercial" src="https://app.powerbi.com/view?r=eyJrIjoiY2RhMGIzOTEtNDVmMy00NjQxLTg3MjktNTgxNGI3M2RjMWZjIiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
